import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, IPromise } from "angular";
import { IFieldArray } from "AngularFormly";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import fieldHelpers from "../../../../app/ui-formly/fieldHelpers";

import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../app/records/forms/formly/fieldConfigurationHelpers";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";

export class ContactBookFormController implements IOnInit {
  static $inject = [
    //FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    UserProfileName,
  ];
  model: any;
  formFields!: IFieldArray;
  contactBook!: any;
  contactBookId: string = "";
  authService: any;
  constructor(
    private readonly $state: StateService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    public readonly userProfile: UserProfile
  ) {}

  private initializeFormFields() {
    const that = this;

    interface ValidatorConfig {
      expression: (value: any) => boolean;
      message: string;
    }

    const phoneFieldConfig = {
      key: "Contact",
      name: "Contact",
      type: "input",
      templateOptions: {
        label: "Phone Number",
        placeholder: "Ex. 000-000-0000",
      },
    };

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "Title",
            name: "Title",
            label: "Title ",
            required: true,
          }),
          {
            key: "AddressBookTypeId",
            name: "AddressBookTypeId",
            type: "selectAsync",
            templateOptions: {
              label: "Type",
              showAddButton: true,
              query: [
                "$scope",
                serverUtilityName,
                function ($scope: any, server: ServerUtility) {
                  return function (search: string) {
                    return server.lookupQuery({
                      search,
                      url: "/api/addressBook/AddressBookType",
                    });
                  };
                },
              ],
              saveNewItem: [
                serverUtilityName,
                function (server: ServerUtility) {
                  return function (name: string) {
                    return server.post({
                      url: "/api/addressBook/AddressBookType",
                      postObject: {
                        Name: name,
                        TypeName: name,
                      },
                    });
                  };
                },
              ],
              getDefaultItem: function (model: any) {
                return {
                  Id: model.AddressBookTypeId,
                  Name: model.AddressBookType?.Name ?? "",
                };
              },
            },
          },

          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Contact Name ",
          }),
        ],
        3
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "BusinessName",
            name: "BusinessName",
            label: "Business Name ",
          }),

          fieldHelpers.simpleStringField({
            key: "Email",
            name: "Email",
            label: "Email address ",
          }),
          phoneFieldConfig,
        ],
        3
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "CellPhone",
            name: "CellPhone",
            label: "Cell Phone ",
          }),

          fieldHelpers.textAreaField({
            key: "Address",
            name: "Address",
            label: "Address",
            rows: 3,
          }),
        ],
        2
      ),
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    this.contactBookId = this.$stateParams["contactBookId"];
    this.model = this.contactBook ? this.contactBook.Results[0] : {};
    this.model.Id = this.contactBook ? this.contactBook.Results[0].Id : null;
    this.model.AddressBookType = this.contactBook
      ? {
          Id: this.contactBook.Results[0].AddressBookTypeId,
          Name: this.contactBook.Results[0].TypeName,
        }
      : null;
    this.initializeFormFields();
  }

  submit(): IPromise<void> {
    const isNew = !this.model.Id;

    const serverPromise = isNew
      ? this.serverUtility.post({
          url: `/api/addressBook/AddressBook`,
          postObject: this.model,
        })
      : this.serverUtility.put({
          url: `/api/addressBook/AddressBook`,
          updateObject: this.model,
        });

    return serverPromise.then(() => {
      this.$state.go("^.grid");
    });
  }

  cancel() {
    return this.$state.go("^.grid");
  }
}
